import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { IonicModule, ModalController } from '@ionic/angular';
import { PrivacyPolicyService } from '../privacy-policy.service';
import { PRIVACY_POLICY_CONFIG } from '../privacy-policy.module';
import { AfterSplashScreen } from '@libs/util/shared';

@AfterSplashScreen()
@Component({
  selector: 'mrf-privacy-policy-modal',
  templateUrl: './privacy-policy-modal.component.html',
  styleUrls: ['./privacy-policy-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IonicModule],
})
export class PrivacyPolicyModalComponent {
  private readonly modalController = inject(ModalController);
  private readonly privacyPolicyService = inject(PrivacyPolicyService);
  private readonly config = inject(PRIVACY_POLICY_CONFIG);
  privacyPolicyUrl = this.config.privacyPolicyUrl;
  privacyPolicyAccepted = false;

  setPolicyAccepted(event: Event) {
    this.privacyPolicyAccepted = (event as CustomEvent).detail.checked;
  }
  confirm() {
    this.privacyPolicyService.acceptPrivacyPolicy();
    this.modalController.dismiss({}, 'confirm');
  }
}
